module.exports = __webpack_public_path__ + "static/img/icon10.7bec7769.svg";